import { defineMessages } from 'react-intl';

export const AiAdvisoryLayoutMessages = defineMessages({
  tabSettings: {
    id: 'administration.tab.aiAdvisoryTabs.settings',
    defaultMessage: 'Settings',
  },
  tabTenantContext: {
    id: 'administration.tab.aiAdvisoryTabs.tenantContext',
    defaultMessage: 'Tenant Context',
  },
});
